module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"yearsOld":"0 лет | {n} год | {n} года | {n} лет"}}')
  delete Component.options._Ctor
}
